import React from "react"
import Switch from "react-switch"
import PropTypes from "prop-types"
import { getFormattedTime } from "utils"
import { SortIcon } from "components/Table_SortColumnIcon"
import ExperienceToggle from "./experienceToggle"
import DragAndDropToggle from "../dragAndDropToggle"

const experiencesListColumns = (
  handleCheckAllItems,
  isCategoriesOn,
  publishChangeHandler,
  setEventsSortOptions
) => {
  return [
    {
      text: "",
      dataField: "drag_drop",
      formatter: (cellContent, exp) => (
        <>
          {isCategoriesOn ? (
            <span className={"drag-drop-button"}>
              <i className="bx bx-sm bx-menu"></i>
            </span>
          ) : (
            <DragAndDropToggle />
          )}
        </>
      ),
    },
    {
      text: "",
      dataField: "select",
      headerFormatter: (col, colIndex, { sortElement }) => (
        <>
          <input
            type="checkbox"
            onChange={event => handleCheckAllItems(event.target.checked)}
          />
        </>
      ),
      formatter: (cellContent, exp) => (
        <>{isCategoriesOn ? <></> : <ExperienceToggle experience={exp} />}</>
      ),
    },
    {
      text: "Name",
      dataField: "name",
      sort: true,
      sortCaret: order => (
        <span className="sort-button">
          <SortIcon order={order} />
        </span>
      ),
      formatter: (cellContent, exp) => (
        <>
          {isCategoriesOn ? (
            <h5 className="font-size-13 mb-1">{exp.name}</h5>
          ) : (
            exp.name
          )}
        </>
      ),
      filterValue: (cellContent, exp) => {
        return isCategoriesOn ? exp.subRows?.map(row => row.name) : exp.name
      },
      classes: "col-4",
      onSort: (field, order) => {
        if (!isCategoriesOn) setEventsSortOptions({ o: field, od: order })
      },
    },
    {
      text: "Business Unit",
      dataField: "business_unit",
      formatter: (cellContent, exp) => (
        <>
          {isCategoriesOn ? (
            <></>
          ) : exp.business_unit ? (
            exp.business_unit.name
          ) : (
            "-"
          )}
        </>
      ),
      classes: "col-2",
    },
    {
      dataField: "hosts[0].display_name",
      text: "Created by",
      formatter: (cellContent, exp) => (
        <>
          {isCategoriesOn ? <></> : exp.hosts ? exp.hosts[0].display_name : "-"}
        </>
      ),
      classes: "col-2",
    },
    {
      dataField: "updated_at",
      text: "Last Modified",
      formatter: (cellContent, exp) => (
        <>
          {isCategoriesOn ? (
            <></>
          ) : (
            <div className={"font-size-12"}>
              {exp.updated_at ? getFormattedTime(exp.updated_at) : "-"}
            </div>
          )}
        </>
      ),
      classes: "col-2",
    },
    {
      text: "# Users",
      dataField: "guests_nr",
      formatter: (cellContent, exp) => (
        <>{isCategoriesOn ? <></> : exp.guests_nr}</>
      ),
      classes: "col-1",
    },
    {
      dataField: "published",
      text: "Published",
      formatter: (cellContent, exp) => (
        <>
          {isCategoriesOn ? (
            <></>
          ) : (
            <Switch
              checked={exp.published}
              onChange={() => {
                publishChangeHandler(exp, !exp.published)
              }}
              onColor="#2ECC71"
              offColor="#E74C3C"
              name="publishCheck"
              height={20}
              width={40}
              handleDiameter={18}
              uncheckedIcon={false}
              checkedIcon={false}
            />
          )}
        </>
      ),
      classes: "col-1",
    },
    {
      dataField: "order",
      text: "",
      hidden: true,
      sort: true,
      formatter: (cellContent, exp, rowIndex) => {
        return <>{isCategoriesOn ? <></> : <div>{exp.order}</div>}</>
      },
    },
    {
      dataField: "actions",
      text: "",
      formatter: () => (
        <div
          style={{
            padding: "0.75rem 0.75rem",
            height: "18px",
            width: "33px",
          }}
        ></div>
      ),
    },
  ]
}

experiencesListColumns.propTypes = {
  handleCheckAllItems: PropTypes.func,
  isCategoriesOn: PropTypes.bool,
  publishChangeHandler: PropTypes.func,
  setEventsSortOptions: PropTypes.func,
}

export default experiencesListColumns
